export const GET_LEADS_PER_AGENT_SUCCESS = 'GET_LEADS_PER_AGENT_SUCCESS'
export const SET_FETCHING_LEADS_PER_AGENT = 'SET_FETCHING_LEADS_PER_AGENT'
export const SET_LEADS_PER_AGENT_FILTERS = 'SET_LEADS_PER_AGENT_FILTERS'
export const RESET_LEADS_PER_AGENT_FILTERS = 'RESET_LEADS_PER_AGENT_FILTERS'
